import { createSlice } from '@reduxjs/toolkit';
import { DateRange } from './dateRangeSlice';

type Action = { payload: DateRange };

const initialState: DateRange = { start: null, end: null };

const dateComparisonRangeSlice = createSlice({
  name: 'dateComparisonRange',
  initialState,
  reducers: {
    updateDateComparisonRange(state: DateRange, action: Action) {
      state.start = action.payload.start;
      state.end = action.payload.end;
    },
  },
});

export const { updateDateComparisonRange } = dateComparisonRangeSlice.actions;

export default dateComparisonRangeSlice.reducer;
